<template>
  <div class="breadcrumb-container">
    <div class="breadcrumb-content">
      <div class="breadcrumb-inner">
        <a-breadcrumb>
          <a-breadcrumb-item :style="index == value.length -1 ? 'color: #1da1f2' : ''"
                             v-for="(item,index) in value" :key="index">{{ item }}
          </a-breadcrumb-item>
        </a-breadcrumb>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumb",
  props: {
    value: {
      type: Array, // 定义参数类型，这里假设是字符串
      required: true, // 设置为必需参数
    }
  }
}
</script>

<style scoped>
/* Breadcrumb容器样式 */
.breadcrumb-container {
  width: 100%;
  height: 62px;
  display: flex;
  justify-content: center;
  border-bottom: 1px #D8D8D8 solid;
  /* 移除固定的margin-top，改为自适应 */
  margin-top: 0;
}

/* Breadcrumb内容区域 */
.breadcrumb-content {
  width: 100%;
  max-width: 1200px;
  height: 100%;
  display: flex;
  align-items: center;
}

/* Breadcrumb内部区域 */
.breadcrumb-inner {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 20px;
}
</style>
